import { Box, styled, TextV2 } from '@withjoy/joykit';

export const StyledTitleText = styled(TextV2)``;

export const StyledSubText = styled(TextV2)`
  text-align: center;
`;

export const StyledForm = styled.form`
  width: 100%;
`;

export const StyledInputWrapper = styled(Box)<{ $focusColor?: string }>`
  *:focus-within::after {
    /* !important required: JoyKit's useFocusBoxStyles generates the focus ring CSS at the same specificity */
    box-shadow: ${p => (p.$focusColor ? `0 0 0 2px ${p.$focusColor}` : 'none')} !important;
  }
`;

export const formControlOverrides = {
  Label: {
    props: {
      visibility: 'hidden',
    },
  },
};
